module.exports = __webpack_public_path__ + "img/knzb-events.84d62b49.webp";